import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Box, Heading, VStack, ChakraProvider } from "@chakra-ui/react";
import Home from "./pages/Home";
import DataNomad from "./pages/DataNomad";
import Subscribe from "./pages/Subscribe";
import Demo from "./pages/Demo";
import TermsAndConditions from "./pages/terms";
import PrivacyPolicy from "./pages/privacy";
import CookiesPolicy from "./pages/cookies";
import LoginPage from './pages/Login';
import PaymentSuccess from './pages/success';
import PaymentDeclined from './pages/declined';

// A simple wrapper component to check authentication and redirect
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('demoAuthToken');
  if (!token) {
    // If no token, redirect to login. Replace prevents going back to this unauthenticated route.
    return <Navigate to="/login" replace />;
  }
  return children; // If token exists, render the child component (e.g., DemoPage)
};


function App() {
  return (
    <ChakraProvider>
      <Router>
	<Routes>
	  <Route path="/" element={<Home />} />
	  <Route path="/datanomad" element={<DataNomad />} />
	  <Route path="/subscribe" element={<Subscribe />} />
	  <Route path="/demo" element={<ProtectedRoute><Demo /></ProtectedRoute>} />
	  <Route path="/terms" element={<TermsAndConditions />} />
	  <Route path="/privacy" element={<PrivacyPolicy />} />
	  <Route path="/cookies" element={<CookiesPolicy />} />
	  <Route path="/login" element={<LoginPage />} />
  	  <Route path="/success" element={<PaymentSuccess />} />
  	  <Route path="/declined" element={<PaymentDeclined />} />
	</Routes>
      </Router>
    </ChakraProvider>
   );
 }

export default App;
